<div class="flex flex-col gap-4 items-stretch justify-between">
	<app-sale-condo-corp-search-card />
	<app-sale-condo-management-type
		*ngIf="shouldDisplayManagementType$ | async"
	/>
	<app-sale-condo-mgmt-search-card
		*ngIf="shouldDisplayCondoManagement$ | async"
	/>
</div>
